import axios from 'axios';

import ENDPOINT from '../../context/EndPoint';

const AdminAddPostPoints = async ({payload}) => {

          const formData = new FormData();

           formData.append('session',payload.user);
           formData.append('post_id',payload.post_id);
           formData.append('points',payload.points);


           try{
               const res = await axios.post(ENDPOINT+"add-post-points.php", formData,{
                    headers: {
                        'content-type': 'multipart/form-data'
                    }
                });
                if(res.data){
                    return res.data
             
                }
           }
           catch(error){

return error
           }

     




}

export default AdminAddPostPoints